/* eslint-disable security/detect-object-injection */
export const SUPPORTED_PAGE_TYPES = ['basket', 'plp', 'pdp'] as const;
export type PageType = (typeof SUPPORTED_PAGE_TYPES)[number];

export const eventBusEventMap: Record<
  PageType | 'page',
  { getItems?: string; getPage?: string }
> = {
  basket: { getItems: 'eventpulse/view_cart' },
  page: { getPage: 'eventpulse/page_view' },
  plp: {},
  pdp: {},
};

export const latestEventBusData: Record<string, any> = {};

export async function hydrateAndSubscribeEventBus(
  eventMap: Record<string, { getItems?: string; getPage?: string }>,
  latestData: Record<string, any>,
  eventBus: {
    mostRecentEventData?: Map<string, any>;
    subscribe: (
      event: string,
      cb: (data: any) => void,
    ) => { unsubscribe: () => void };
  },
): Promise<void> {
  const missingEventPromises: Promise<void>[] = [];

  Object.values(eventMap).forEach((entry) => {
    ['getItems'].forEach((key) => {
      const eventName = entry[key as keyof typeof entry];
      if (!eventName) return;

      const hasRecent =
        eventBus.mostRecentEventData instanceof Map &&
        eventBus.mostRecentEventData.has(eventName);

      if (hasRecent) {
        latestData[eventName] = eventBus.mostRecentEventData?.get(eventName);
      } else {
        const promise = new Promise<void>((resolve) => {
          const { unsubscribe } = eventBus.subscribe(eventName, (data: any) => {
            latestData[eventName] = data;
            unsubscribe();
            resolve();
          });
        });
        missingEventPromises.push(promise);
      }

      eventBus.subscribe(eventName, (data: any) => {
        latestData[eventName] = data;
        console.debug(`[eventBusUtils] Updated ${eventName} with new data.`);
      });
    });
  });

  await Promise.all(missingEventPromises);
}

export function extractItemsFromEventData(eventData: any) {
  const items: { itemNumbers: string[]; productGroupIds: string[] } = {
    itemNumbers: [],
    productGroupIds: [],
  };
  const dataItems = eventData?.items ?? eventData?.ecommerce?.items ?? [];
  dataItems.forEach((item: any) => {
    if (item.itemLineNum) items.itemNumbers.push(String(item.itemLineNum));
    if (item.productGroupId)
      items.productGroupIds.push(`${item.productGroupId}`);
  });
  return items;
}

export function getItemsFromEventBus(
  eventBusData: Record<string, any>,
  pageType?: string,
) {
  if (pageType === 'basket') {
    const eventName = eventBusEventMap.basket?.getItems;

    if (eventName && eventBusData[eventName]) {
      const extractedItems = extractItemsFromEventData(eventBusData[eventName]);
      return extractedItems;
    }
  }

  return { itemNumbers: [], productGroupIds: [] };
}

export function publishEventBusMockData() {
  if (
    typeof window !== 'undefined' &&
    window.eventBus &&
    process.env.NODE_ENV !== 'production'
  ) {
    window.eventBus.publish('eventpulse/page_view', {
      page: {
        pageID: 'basket.basket',
        platform: 'skyscape',
        category: 'checkout',
        experimentVariant: '',
      },
    });

    window.eventBus.publish('eventpulse/view_cart', {
      ecommerce: {
        basketID: 'abc',
        itemCnt: 2,
        items: [
          {
            itemBrand: 'Adidas',
            itemCategory: 'Trainers',
            itemLineNum: '12WNP',
            productGroupId: '2000015187',
          },
          {
            itemBrand: 'Nike',
            itemCategory: 'Trainers',
            itemLineNum: '99WNP',
            productGroupId: '2000060000',
          },
        ],
        value: 303,
      },
    });
  }
}
